import React, { Component } from "react";
import {
  BrowserView,
  MobileView

} from "react-device-detect";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import {Row, Col} from 'react-bootstrap';
import "./index.css";

library.add(
  fas
  // more icons go here
);




class Dropzone extends Component {
  constructor(props) {
    super(props);
    this.state = { highlight: false };
    this.fileInputRef = React.createRef();

    this.openFileDialog = this.openFileDialog.bind(this);
    this.onFilesAdded = this.onFilesAdded.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  openFileDialog() {
    if (this.props.disabled) return;
    this.fileInputRef.current.click();
  }

  onFilesAdded(evt) {
    if (this.props.disabled) return;
    const files = evt.target.files;
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      this.props.onFilesAdded(array);
    }
  }

  onDragOver(event) {
    event.preventDefault();
    if (this.props.disabled) return;
    this.setState({ highlight: true });
  }

  onDragLeave(event) {
    this.setState({ highlight: false });
  }

  onDrop(event) {
    event.preventDefault();
    if (this.props.disabled) return;
    const files = event.dataTransfer.files;
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      this.props.onFilesAdded(array);
    }
    this.setState({ highlight: false });
  }

  fileListToArray(list) {
    const array = [];
    for (var i = 0; i < list.length; i++) {
      array.push(list.item(i));
    }
    return array;
  }

  render() {
    return (
      <div
        className={`Dropzone ${this.state.highlight ? "Highlight" : ""} ${this.props.disabled ? "disabled" : ""}`}
        onDragOver={this.onDragOver}
        onDragLeave={this.onDragLeave}
        onDrop={this.onDrop}
        onClick={this.openFileDialog}
      >
        <input
          ref={this.fileInputRef}
          className="FileInput"
          type="file"
          multiple
          onChange={this.onFilesAdded}
          accept="image/*,application/pdf"
        />
        <FontAwesomeIcon
          alt="upload"
          icon={['fas', 'cloud-upload-alt']}
          className="dropzone-icon Icon"
          size="7x"
        />
        <BrowserView>
          <Row className="dropzone-text justify-content-center">
            <Col><strong>Drag and drop image or PDF files here for uploading,<br /> or click to select files for uploading<br />(Max Size 10MB)</strong>
            </Col>
          </Row>
        </BrowserView>
        <MobileView>
          <Row className="dropzone-text justify-content-center">
            <Col><strong>Click here to select files for uploading<br /> or to take a picture of the document.<br />(Max Size 10MB)</strong></Col>
          </Row>
        </MobileView>
      </div>
    );
  }
}

export default Dropzone;
